module.exports = __webpack_public_path__ + "static/media/shirt3.40bf4ff0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Product/shirt3.png
// module id = 260
// module chunks = 0